// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"16772aff","453":"ba8c5203","732":"29b862ca","977":"a66f96ec"}[chunkId] + ".chunk.js";
};